let applicationList = [
  {
    applicationId: "pc-jszzzctlyt",
    text: "大庆市驾驶证证照",
    userType: 1,
  },
  {
    applicationId: "pc-jszzzdypszaa",
    text: "大庆市驾驶证打印",
    userType: 1,
    print: true,
  },

  {
    applicationId: "pc-hzzzwuyxx",
    text: "大庆市护照查询",
    userType: 1,
  },
  {
    applicationId: "pc-hzzzdyeywnh",
    text: "大庆市护照打印",
    userType: 1,
    print: true,
  },
  {
    applicationId: "pc-hkbzzgygex",
    text: "大庆市户口本查询",
    userType: 1,
  },
  {
    applicationId: "pc-hkbzzdyhjnwz",
    text: "大庆市户口本打印",
    userType: 1,
    print: true,
  },

  {
    applicationId: "pc-jzzzzxnpsi",
    text: "大庆市居住证查询",
    userType: 1,
  },
  {
    applicationId: "pc-jzzzzdyeqvkg",
    text: "大庆市居住证打印",
    userType: 1,
    print: true,
  },
  {
    applicationId: "pc-sfzzzdruvz",
    text: "大庆市身份证查询",
    userType: 1,
  },
  {
    applicationId: "pc-sfzzzdyyrkqj",
    text: "大庆市身份证打印",
    userType: 1,
    print: true,
  },
  {
    applicationId: "pc-jkzcxibejd",
    text: "大庆市从业人员健康检查合格证明",
    userType: 1,
  },
  {
    applicationId: "pcd-dqsgjjcxxvnto",
    text: "大庆市公积金查询",
    userType: 1,
  },
  {
    applicationId: "pc-dqsgjjdyctdpu",
    text: "公积金缴存证明打印",
    userType: 1,
    print: true,
  },
  {
    applicationId: "pc-dqsrqjyxkzwrcqz",
    text: "大庆市燃气经营许可证",
    userType: 2,
  },
  {
    applicationId: "pc-dqsrqjyxkzdyejykj",
    text: "大庆市燃气经营许可证打印",
    userType: 2,
    print: true,
  },
  {
    applicationId: "pc-dqssydwfrzstbrda",
    text: "大庆市事业单位法人证书",
    userType: 2,
  },
  {
    applicationId: "pc-dqssydwfrzsdyrglwk",
    text: "大庆市事业单位法人证书打印",
    userType: 2,
    print: true,
  },
  {
    applicationId: "pc-dqskdywjyxkzmpbsg",
    text: "大庆市快递业务经营许可证",
    userType: 2,
  },
  {
    applicationId: "pc-dqskdywjyxkzdywhran",
    text: "大庆市快递业务经营许可证打印",
    userType: 2,
    print: true,
  },
  {
    applicationId: "pc-mscyenbli",
    text: "码上创业",
    userType: 2,
  },
  {
    applicationId: "pc-mswqmvuze",
    text: "码上维权",
    userType: 2,
  },
  {
    applicationId: "pc-msgxpnyoe",
    text: "码上共享",
    userType: 2,
  },
  {
    applicationId: "pc-wxzwfwsjhcqfce",
    text: "我向政务服务说句话",
  },
  {
    applicationId: "pc-msrzesrrz",
    text: "码上融资",
    userType: 2,
  },
  {
    applicationId: "pc-frhmdcxewlnc",
    text: "法人黑名单查询",
    userType: 2,
  },
  {
    applicationId: "pc-qyhmdxxgitwf",
    text: "企业黑名单信息",
    userType: 2,
  },
  {
    applicationId: "pc-qyhmdzmbldyvcnnu",
    text: "企业黑名单证明办理打印",
    userType: 2,
    print: true,
  },
  {
    applicationId: "pc-cbpzcxugmcr",
    text: "参保凭证查询",
    userType: 1,
  },
  {
    applicationId: "pc-sbjfzmdykopsr",
    text: "社保缴费证明打印",
    userType: 1,
  },
  {
    applicationId: "pc-grsbcbxxzmbldylluvc",
    text: "个人社保参保信息证明办理打印",
    userType: 1,
    print: true,
  },
  {
    applicationId: "pc-dqsgrsbcbxxgejpc",
    text: "大庆市个人社保参保信息",
    userType: 1,
  },
  {
    applicationId: "pc-grsydjxxcxcxiby",
    text: "个人失业登记信息查询",
    userType: 1,
  },
  {
    applicationId: "PC-xsecszmdjlektz",
    text: "新生儿出生证明登记",
    userType: 1,
  },
  {
    applicationId: "pc-gjcsyxzmblcxwnjxw",
    text: "国家出生医学证明办理查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjcsyxzmbldykszzo",
    text: "国家出生医学证明办理打印",
    userType: 1,
    print: true,
  },
  {
    applicationId: "pc-bdcdjxxcxghvrl",
    text: "不动产登记信息查询",
    userType: 1,
  },
  {
    applicationId: "pc-bdcdjxxyzdylwv",
    text: "不动产产权验真",
    userType: 1,
    print: true,
  },
  {
    applicationId: "pc-dzyyzzxxcxoysen",
    text: "电子营业执照信息查询",
    userType: 2,
  },
  {
    applicationId: "pc-dzyyzzxxdyxxnkx",
    text: "电子营业执照信息打印",
    userType: 2,
    print: true,
  },
  {
    applicationId: "pc-gjjdkjdcxttyjk",
    text: "公积金贷款进度查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjhdjlcxxmvap",
    text: "公积金还贷记录查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjtqjlcxlxxka",
    text: "公积金提取记录查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjtqjdcxvnovp",
    text: "公积金提取进度查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjcjlcxudcjj",
    text: "公积金缴存记录查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjjcxxcxmxqdt",
    text: "公积金缴存信息查询",
    userType: 1,
  },
  {
    applicationId: "pc-grgxxwzmbldykfaom",
    text: "个人高校学位证明办理打印",
    userType: 1,
  },
  {
    applicationId: "pc-grgxxwzscxalffx",
    text: "高校学位证书查询",
    userType: 1,
  },
  {
    applicationId: "pc-hydjyydlhpo",
    text: "婚姻登记预约",
    userType: 1,
  },

  // 新补其他部分
  {
    applicationId: "pc-dqshydjxxhyiyccs",
    text: "大庆市婚姻登记信息核验",
    userType: 1,
  },
  {
    applicationId: "pc-bdcdjxxyzdylwv",
    text: "婚姻登记证明办理打印",
    userType: 1,
    print: true,
  },
  {
    applicationId: "pc-hygxzmhsgin",
    text: "婚姻关系证明",
    userType: 1,
  },
  {
    applicationId: "pc-grhygxzmbldyagfsx",
    print: true,
    text: "个人婚姻关系证明办理打印",
    userType: 1,
  },
  {
    applicationId: "pc-hhzmcxovyew",
    text: "火化证明查询",
    userType: 1,
  },
  {
    applicationId: "pc-hhzmcxovyew",
    text: "死亡医学证明信息查询",
    userType: 1,
  },
  {
    applicationId: "pc-gscfxxcxffikr",
    text: "公示处罚信息查询",
    userType: 2,
  },
  {
    applicationId: "pc-sgjbxxzmrsb",
    text: "事故基本信息",
    userType: 1,
  },
  {
    applicationId: "pc-qyfrggxypjjgdhnfu",
    text: "企业法人公共信用评价结果",
    userType: 2,
  },
  {
    applicationId: "pc-qyfrggxypjjgdyadkcq",
    text: "企业法人公共信用评价结果打印",
    userType: 2,
    print: true,
  },
  {
    applicationId: "pc-gqczbgdjxxtooau",
    text: "股权出质变更登记信息",
    userType: 2,
  },
  {
    applicationId: "pc-jzscqyxxvbjox",
    text: "建筑市场企业信息",
    userType: 2,
  },
  {
    applicationId: "pc-jzscryxxjnruc",
    text: "建筑市场人员信息",
    userType: 2,
  },
  {
    applicationId: "pc-jzscryxxjnruc",
    text: "建筑市场人员信息证明办理打印",
    userType: 2,
    print: true,
  },
  {
    applicationId: "zybbsydwcxqcdoz",
    text: "中央编办事业单位查询",
    userType: 2,
  },
  {
    applicationId: "pc-sydwxxcxggisw",
    text: "事业单位信息查询",
    userType: 2,
  },
  {
    applicationId: "pc-sydwxxcxggisw",
    text: "事业单位信息证明办理打印",
    userType: 2,
    print: true,
  },
  {
    applicationId: "pc-qytzrxxsggkh",
    text: "企业投资人信息",
    userType: 2,
  },
  {
    applicationId: "pc-qytzrzmbldyjgjhl",
    print: true,
    text: "企业投资人证明办理打印",
    userType: 2,
  },
  {
    applicationId: "pc-nbxxcxzapcd",
    text: "年报信息查询",
    userType: 2,
  },
  {
    applicationId: "pc-nbxxcxdyvtxev",
    print: true,
    text: "年报信息查询打印",
    userType: 2,
  },
  {
    applicationId: "pc-ycmlztxxacter",
    text: "异常名录主体信息",
    userType: 2,
  },
  {
    applicationId: "pc-jgsyylgrjbxxlvyaz",
    text: "机关事业养老个人基本信息",
    userType: 1,
  },
  {
    applicationId: "pc-dxxxcxuonov",
    text: "吊销信息查询",
    userType: 2,
  },
  {
    applicationId: "pc-jnryzyzgzsxxcxjhqiw",
    text: "技能人员职业资格证书信息查询",
    userType: 1,
  },
  {
    applicationId: "pc-qysldjxxkinql",
    text: "企业设立登记信息",
    userType: 2,
  },
  {
    applicationId: "pc-frhmdzmbldygddib",
    text: "法人黑名单证明办理打印",
    userType: 2,
    print: true,
  },
  {
    applicationId: "pc-sbjfxxqyrwzfh",
    text: "信用_社保缴费信息",
    userType: 2,
  },
  {
    applicationId: "pc-ssjj_qyjbxxpljxz",
    text: "省市监局_企业基本信息",
    userType: 2,
  },
  // {
  // 	applicationId: "pc-jkzcxibejd",
  // 	text: "寄递办",
  // 	userType: 2,
  // },
];
let applicationName = "不动产产权验真";
export default {
  applicationName,
  applicationList,
};

